import React, { useEffect, useState } from 'react';
import { ShieldCheck, ChevronRight } from 'lucide-react';
import { Card } from './ui/card';
import { apiService } from '../services/api';
import TeamThreadDialog from './TeamThreadDialog';

const TeamInboxCard = () => {
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);
  const load = () => apiService.inbox.list().then((r) => setData(r.data.data)).catch(() => setData({ threads: [], unread: 0 }));
  useEffect(() => { load(); }, []);
  if (!data || data.threads.length === 0) return null;
  return (
    <Card className="p-6 space-y-3" data-testid="team-inbox-card">
      <div>
        <h2 className="text-lg font-semibold flex items-center"><ShieldCheck className="w-5 h-5 mr-2 text-rose-600" />Messages from the FlameLink team{data.unread > 0 && <span className="ml-2 text-xs bg-rose-100 text-rose-700 rounded-full px-2 py-0.5" data-testid="team-inbox-unread">{data.unread} new</span>}</h2>
        <p className="text-sm text-gray-600 mt-1">Private conversations with our team. You can reply here.</p>
      </div>
      <ul className="divide-y">
        {data.threads.map((t) => (
          <li key={t.id}>
            <button type="button" className="w-full flex items-center justify-between py-3 text-left" onClick={() => setOpenId(t.id)} data-testid={`team-inbox-thread-${t.id}`}>
              <div className="min-w-0"><p className="font-medium text-gray-900 truncate">{t.subject}</p><p className="text-xs text-gray-500">{t.replies.length} repl{t.replies.length === 1 ? 'y' : 'ies'} · last {t.last_reply_by === 'member' ? 'you' : 'team'} · {new Date(t.last_reply_at).toLocaleDateString()}{t.status === 'closed' ? ' · closed' : ''}</p></div>
              <ChevronRight className="w-4 h-4 text-gray-400" />
            </button>
          </li>
        ))}
      </ul>
      <TeamThreadDialog threadId={openId} open={!!openId} onOpenChange={(o) => !o && setOpenId(null)} onChanged={load} />
    </Card>
  );
};

export default TeamInboxCard;
